<ion-content [fullscreen]="true">
  <div class="sign-in-wrap">
    <div class="form-wrap">
      <div class="language-toggle-container">
        <ion-button mode="md" fill="outline" class="language-toggle" (click)="toggleLanguage()">
          {{ selectedLanguage() | uppercase }}
        </ion-button>
      </div>

      <div class="logo-img-wrap">
        <img src="logo-blue.svg" alt="Logo" class="logo-img" />
      </div>

      <ion-item>
        <ion-input
          type="email"
          [label]="translate.instant('AUTH.SIGN_IN.EMAIL')"
          labelPlacement="floating"
          [(ngModel)]="email"></ion-input>
      </ion-item>

      <ion-item>
        <ion-input
          [type]="showPassword() ? 'text' : 'password'"
          [label]="translate.instant('AUTH.SIGN_IN.PASSWORD')"
          labelPlacement="floating"
          [(ngModel)]="password"></ion-input>
        <ion-icon
          class="extra-small"
          slot="end"
          [name]="showPassword() ? 'eye' : 'eye-off'"
          (click)="togglePassword()"></ion-icon>
      </ion-item>

      <!-- <ion-item lines="none">
        <h5> 
          <a href="#" class="forgot-password">Forgot Password ?</a>
        </h5>
      </ion-item> -->

      <ion-button expand="block" type="submit" (click)="signInWithCredentials()">{{
        translate.instant("AUTH.SIGN_IN.SUBMIT")
      }}</ion-button>

      <div class="dont-have-account-wrap">
        <h4 class="signup-text">
          {{ "AUTH.SIGN_IN.NO_ACCOUNT" | translate }}
          <a routerLink="/login/sign-up">{{ translate.instant("AUTH.SIGN_IN.SIGN_UP") }}</a>
        </h4>
      </div>

      <div>
        <div class="external-sign-in-btn" (click)="signInWithGoogle()">
          <ion-img class="google-img" src="google-logo.png"></ion-img>
          <ion-text color="primary">
            <h4>{{ "AUTH.SIGN_IN.GOOGLE" | translate }}</h4>
          </ion-text>
        </div>
      </div>

      <div>
        @if (isIOS) {
        <div class="external-sign-in-btn apple-btn" (click)="signInWithApple()">
          <ion-icon name="logo-apple"></ion-icon>
          <ion-text color="white">
            <h4>{{ "AUTH.SIGN_IN.APPLE" | translate }}</h4>
          </ion-text>
        </div>
        }
      </div>

      <!-- Terms and Privacy Notice -->
      <div class="terms-notice">
        <ion-text color="medium">
          <p class="terms-text">
            {{ "AUTH.SIGN_IN.BY_SIGNING_IN" | translate }}
            <a href="#" (click)="openTerms($event)">{{ "AUTH.SIGN_IN.TERMS" | translate }}</a>
            {{ "AUTH.SIGN_IN.AND" | translate }}
            <a href="#" (click)="openPrivacy($event)">{{ "AUTH.SIGN_IN.PRIVACY_POLICY" | translate }}</a>
          </p>
        </ion-text>
      </div>

      <div class="ion-text-center ion-margin">
        <ion-text color="tertiary">
          <p [routerLink]="['/home']" class="as-guest-text">{{ "AUTH.SIGN_IN.CONTINUE_AS_GUEST" | translate }}</p>
        </ion-text>
      </div>
    </div>
  </div>
</ion-content>
